import React, { useState, useEffect } from 'react'
import { Col, Drawer, Input, Panel, Row, SelectPicker, Table } from 'rsuite'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import {
  exportAiEvaluationReport,
  getAiEvaluationHistory,
  searchAiEvaluationReport,
} from '../../redux/actions/aiEvaluation'
import { doneLoading, startLoading } from '../../utils/loading'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import AIEvaluationResultHistory from './AIEvaluationResultHistory'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { tableViewSize } from '../../utils/tableViewSizeUtil'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadFile } from '../../utils/fileUtil'

export default function AIEvaluationReportWidget({ schema, pageNum, pageSize }) {
  const { ColumnGroup, Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)

  const [datas, setDatas] = useState(schema?.datas || [])
  const [evaluationHistory, setEvaluationHistory] = useState()

  const [displayLength, setDisplayLength] = useState(pageSize || 25)
  const [page, setPage] = useState(pageNum || 1)
  const [totalSize, setTotalSize] = useState(0)
  const [viewSize, setViewSize] = useState([])

  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()
  const [budgetYear, setBudgetYear] = useState()
  const [status, setStatus] = useState()
  const [department, setDepartment] = useState()

  useEffect(() => {
    setTotalSize(schema.totalSize)
    setViewSize(tableViewSize(schema.totalSize))
  }, [])

  const handleGetHistory = async (projectCode) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await getAiEvaluationHistory(null, projectCode)
      if (response) {
        setEvaluationHistory(response)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      // setEvaluationHistory({ header: 'ประวัติการประเมินคุณภาพโครงการ' })
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSearch = async (request) => {
    startLoading()
    setIsLoading(true)

    console.log(request)

    try {
      const response = await searchAiEvaluationReport(request)
      // let response = schema
      if (response) {
        setTotalSize(response?.totalSize)
        setDatas(response?.datas || [])
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleExport = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await exportAiEvaluationReport(request)
      let fileName = 'รายงานการประเมินคุณภาพโครงการ.xlsx'
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()

    setIsLoading(false)
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)

    let req = {
      pageNum: 1,
      pageSize: dataKey,
      projectCode: projectCode || undefined,
      projectName: projectName || undefined,
      department: department || undefined,
      budgetYear: budgetYear || undefined,
      status: status || undefined,
    }

    handleSearch(req)
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)

    let req = {
      pageNum: dataKey,
      pageSize: displayLength,
      projectCode: projectCode || undefined,
      projectName: projectName || undefined,
      department: department || undefined,
      budgetYear: budgetYear || undefined,
      status: status || undefined,
    }

    handleSearch(req)
  }

  return (
    <>
      {schema && (
        <Panel
          header={schema.header}
          shaded
          bordered
          collapsible
          defaultExpanded
          style={{ marginTop: 10 }}
        >
          {isLoading && <OverlayLoader />}

          {schema.searchObject && (
            <>
              <Row>
                {schema.searchObject.projectCode && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    {schema.searchObject.projectCode.label}
                    <Input
                      name={schema.searchObject.projectCode.name}
                      defaultValue={projectCode}
                      value={projectCode}
                      placeholder={
                        schema.searchObject.projectCode.hint ||
                        `ระบุ${schema.searchObject.projectCode.label}`
                      }
                      onChange={(value) => {
                        setProjectCode(value)
                      }}
                    />
                  </Col>
                )}

                {schema.searchObject.projectName && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    {schema.searchObject.projectName.label}
                    <Input
                      name={schema.searchObject.projectName.name}
                      defaultValue={projectName}
                      value={projectName}
                      placeholder={
                        schema.searchObject.projectName.hint ||
                        `ระบุ${schema.searchObject.projectName.label}`
                      }
                      onChange={(value) => {
                        setProjectName(value)
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 10 }}>
                {schema.searchObject.budgetYear && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    {schema.searchObject.budgetYear.label}
                    <SelectPicker
                      data={schema.searchObject.budgetYear.options}
                      value={budgetYear}
                      block
                      searchable={false}
                      placeholder={`เลือก ${schema.searchObject.budgetYear.label}`}
                      onChange={(value) => {
                        setBudgetYear(value)
                      }}
                    />
                  </Col>
                )}

                {schema.searchObject.department && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    {schema.searchObject.department.label}
                    <SelectPicker
                      data={schema.searchObject.department.options}
                      value={department}
                      block
                      searchable={false}
                      placeholder={`เลือก ${schema.searchObject.department.label}`}
                      onChange={(value) => {
                        setDepartment(value)
                      }}
                    />
                  </Col>
                )}
              </Row>{' '}
              <Row style={{ marginTop: 10 }}>
                {schema.searchObject.status && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    {schema.searchObject.status.label}
                    <SelectPicker
                      data={schema.searchObject.status.options}
                      value={status}
                      block
                      searchable={false}
                      placeholder={`เลือก ${schema.searchObject.status.label}`}
                      onChange={(value) => {
                        setStatus(value)
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 20 }}>
                <SearchButton
                  children="ค้นหา"
                  disabled={isLoading}
                  onClick={() => {
                    handleSearch({
                      pageNum: page,
                      pageSize: displayLength,
                      projectCode: projectCode || undefined,
                      projectName: projectName || undefined,
                      department: department || undefined,
                      budgetYear: budgetYear || undefined,
                      status: status || undefined,
                    })
                  }}
                />
                <CancelButton
                  children="ยกเลิก"
                  disabled={isLoading}
                  onClick={() => {
                    setProjectCode('')
                    setProjectName('')
                    setDepartment('')
                    setBudgetYear('')
                    setStatus('')
                    handleSearch({
                      pageNum: page,
                      pageSize: displayLength,
                    })
                  }}
                />
              </Row>
            </>
          )}

          <hr />
          <Row style={{ textAlign: 'right' }}>
            <ViewButton
              icon="print"
              children="Export"
              disabled={isLoading}
              onClick={() => {
                handleExport({
                  //pageNum: page,
                  //pageSize: displayLength,
                  projectCode: projectCode,
                  projectName: projectName,
                  department: department,
                  budgetYear: budgetYear,
                  status: status,
                })
              }}
            />
          </Row>
          <Table
            wordWrap
            // height={440}
            autoHeight
            // data={schema.datas}
            headerHeight={80}
            data={datas}
            style={{ marginTop: 10 }}
            loading={isLoading}
          >
            <Column width={90} fixed="left" align="center">
              <HeaderCell>
                <span>ลำดับ</span>
              </HeaderCell>
              <Cell>
                {(_, index) => {
                  return <span>{index + 1}</span>
                }}
              </Cell>
            </Column>
            <Column width={130}>
              <HeaderCell>
                <span>รหัสโครงกร</span>
              </HeaderCell>
              <Cell dataKey="projectCode" />
            </Column>
            <Column width={450}>
              <HeaderCell>
                <span>ชื่อโครงการ</span>
              </HeaderCell>
              <Cell dataKey="projectName" />
            </Column>
            <Column width={130} align="center">
              <HeaderCell>
                <span>ปีงบประมาณ</span>
              </HeaderCell>
              <Cell dataKey="budgetYear" />
            </Column>
            <Column width={200}>
              <HeaderCell>
                <span>สถานะโครงการ</span>
              </HeaderCell>
              <Cell dataKey="projectStatus" />
            </Column>
            <Column width={250}>
              <HeaderCell>
                <span>สถานะย่อยโครงการ</span>
              </HeaderCell>
              <Cell dataKey="projectStep" />
            </Column>
            <Column width={200}>
              <HeaderCell>
                <span>สำนัก</span>
              </HeaderCell>
              <Cell dataKey="department" />
            </Column>
            <Column width={250}>
              <HeaderCell>
                <span>นักวิชาการผู้ประสาน</span>
              </HeaderCell>
              <Cell dataKey="coodiator" />
            </Column>

            <Column width={120} align="center">
              <HeaderCell>
                <span>
                  จำนวนครั้ง
                  <br />
                  ที่กดประเมิน
                </span>
              </HeaderCell>
              <Cell dataKey="evaluationTimes" />
            </Column>
            <ColumnGroup header="ผลประเมินครั้งแรก (ย้งไม่กดส่ง)" align="center">
              <Column width={150}>
                <HeaderCell>
                  <span>วันที่ประเมิน</span>
                </HeaderCell>
                <Cell dataKey="firstDate" />
              </Column>
              <Column width={150}>
                <HeaderCell>
                  <span>คะแนน</span>
                </HeaderCell>
                <Cell dataKey="firstScore" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="ผลประเมินครั้งแรก (นักวิชาการเห็น)" align="center">
              <Column width={150}>
                <HeaderCell>
                  <span>วันที่ประเมิน</span>
                </HeaderCell>
                <Cell dataKey="firstSendDate" />
              </Column>
              <Column width={150}>
                <HeaderCell>
                  <span>คะแนน</span>
                </HeaderCell>
                <Cell dataKey="firstSendScore" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="ผลประเมินสุดท้าย" align="center">
              <Column width={150}>
                <HeaderCell>
                  <span>วันที่ประเมิน</span>
                </HeaderCell>
                <Cell dataKey="lastDate" />
              </Column>
              <Column width={150}>
                <HeaderCell>
                  <span>คะแนน</span>
                </HeaderCell>
                <Cell dataKey="lastScore" />
              </Column>
            </ColumnGroup>

            <Column width={130} fixed="right">
              <HeaderCell>
                <span></span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ViewButton
                      children="ดูประวัติ"
                      disabled={isLoading}
                      onClick={() => {
                        handleGetHistory(rowData.projectCode)
                      }}
                    />
                  )
                }}
              </Cell>
            </Column>
          </Table>

          <TablePagination
            lengthMenu={viewSize}
            activePage={page || 1}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 25}
            total={totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </Panel>
      )}

      <Drawer
        show={!!evaluationHistory}
        onHide={() => setEvaluationHistory('')}
        // size="lg"
        full
        placement="top"
      >
        <Drawer.Header>
          <Drawer.Title>
            <div style={{ paddingTop: 10 }}>{evaluationHistory?.header}</div>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body style={{ maxHeight: '70hv', overflow: 'auto' }}>
          <div style={{ overflowX: 'auto' }}>
            <AIEvaluationResultHistory
              schema={evaluationHistory}
              // autoHeight={false}
              // height={Math.floor(window.innerHeight * 0.7) - 150}
            />
          </div>
        </Drawer.Body>
        <Drawer.Footer>
          <CancelButton onClick={() => setEvaluationHistory('')} children="ปิด" />
        </Drawer.Footer>
      </Drawer>
    </>
  )
}
